import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
    PendingInvoice,
    PendingPickupService,
} from '../../services/pending-pickup.service';

@Component({
    selector: 'app-pickup-forfeiture-modal',
    templateUrl: './pickup-forfeiture-modal.component.html',
    styleUrls: ['./pickup-forfeiture-modal.component.scss'],
})
export class PickupForfeitureModalComponent implements OnInit, OnDestroy {
    pendingInvoices: PendingInvoice[] = [];
    acknowledging: Set<string> = new Set();

    private destroy$ = new Subject<void>();

    constructor(
        private readonly bsModalRef: BsModalRef,
        private readonly pendingPickupService: PendingPickupService,
        private readonly router: Router,
    ) {}

    ngOnInit(): void {
        this.pendingPickupService.pendingInvoices$
            .pipe(takeUntil(this.destroy$))
            .subscribe((invoices: PendingInvoice[]) => {
                this.pendingInvoices = invoices;
                if (invoices.length === 0) {
                    this.bsModalRef.hide();
                }
            });
    }

    schedulePickup(invoiceId: string): void {
        this.bsModalRef.hide();
        this.router.navigate(['/invoice-actions', { id: invoiceId }]);
    }

    acknowledgeForfeiture(invoiceId: string): void {
        this.acknowledging.add(invoiceId);
        this.pendingPickupService
            .acknowledgeForfeiture(invoiceId)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                error: () => this.acknowledging.delete(invoiceId),
            });
    }

    isAcknowledging(invoiceId: string): boolean {
        return this.acknowledging.has(invoiceId);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
